<template>
  <div class="member-container">
    <div class="container">
      <div class="header">
        <h1>🎯 会员中心</h1>
        <p>选择最适合您的会员套餐，解锁更多权益</p>
        <div class="agreement-link">
          <span>购买即表示同意</span>
          <a href="javascript:void(0)" @click="showAgreement">《平台会员服务协议》</a>
        </div>
      </div>

      <div class="membership-cards">
        <!-- 月度会员 -->
        <div
          v-if="monthlyPlan"
          class="card"
          :class="{ 'card-selected': selectedCard === 'monthly' }"
          @click="selectCard('monthly')"
        >
          <div class="card-header">
            <div class="card-title">{{ monthlyPlan.name }}</div>
            <div class="card-price">
              {{ monthlyPlan.member_price }}<span class="card-price-unit">元/月</span>
              <span v-if="monthlyPlan.original_price > monthlyPlan.member_price" class="original-price">
                ¥{{ monthlyPlan.original_price }}
              </span>
            </div>
            <div v-if="monthlyPlan.description" class="card-description">{{ monthlyPlan.description }}</div>
          </div>
          <ul class="card-features">
            <li v-for="priv in monthlyPlan.priv_names.filter(p => p.name !== '价格')" :key="priv.name">
              <span class="feature-icon" :class="priv.has_priv ? 'yes' : 'no'">
                {{ priv.has_priv ? '✓' : '✗' }}
              </span> {{ priv.name }}
            </li>
          </ul>
          <button
            class="btn-purchase"
            @click.stop="purchaseMembership('monthly')"
            :disabled="isLifetimeMember || plansLoading"
          >
            {{ isLifetimeMember ? '您已经是终身会员' : (memberInfo.memberLevel === 'monthly' ? '立即续费' : '立即开通') }}
          </button>
        </div>

        <!-- 终身会员 -->
        <div
          v-if="lifetimePlan"
          class="card featured"
          :class="{ 'card-selected': selectedCard === 'lifetime' }"
          @click="selectCard('lifetime')"
        >
          <div class="card-header">
            <div class="card-title">{{ lifetimePlan.name }}</div>
            <div class="card-price">
              {{ lifetimePlan.member_price }}<span class="card-price-unit">元</span>
              <span v-if="lifetimePlan.original_price > lifetimePlan.member_price" class="original-price">
                ¥{{ lifetimePlan.original_price }}
              </span>
            </div>
            <div v-if="lifetimePlan.description" class="card-description">{{ lifetimePlan.description }}</div>
          </div>
          <ul class="card-features">
            <li v-for="priv in lifetimePlan.priv_names.filter(p => p.name !== '价格')" :key="priv.name">
              <span class="feature-icon" :class="priv.has_priv ? 'yes' : 'no'">
                {{ priv.has_priv ? '✓' : '✗' }}
              </span> {{ priv.name }}
            </li>
          </ul>
          <button
            class="btn-purchase"
            @click.stop="purchaseMembership('lifetime')"
            :disabled="isLifetimeMember || plansLoading"
          >
            {{ isLifetimeMember ? '您已经是终身会员' : '立即开通' }}
          </button>
        </div>

        <!-- 加载状态 -->
        <div v-if="plansLoading" class="plans-loading">
          <el-icon class="is-loading"><Loading /></el-icon>
          <p>正在加载会员套餐...</p>
        </div>
      </div>

<!--      <div class="purchase-quota-section">-->
<!--        <h2>🎬 购买视频生成次数</h2>-->
<!--        <div class="quota-status">-->
<!--          <div class="quota-status-label">当前次数状态</div>-->
<!--          <div class="quota-status-info">-->
<!--            <div>-->
<!--              <div class="quota-status-item-label">本月免费</div>-->
<!--              <div class="quota-status-item-value free">{{ currentQuota.freeQuota }}/{{ currentQuota.freeTotal }}</div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div class="quota-status-item-label">购买余额</div>-->
<!--              <div class="quota-status-item-value purchased">{{ currentQuota.purchased }}次</div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div class="quota-status-item-label">总可用</div>-->
<!--              <div class="quota-status-item-value total">{{ currentQuota.total }}次</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="quota-options">-->
<!--          <div-->
<!--            v-for="option in quotaOptions"-->
<!--            :key="option.count"-->
<!--            class="quota-option"-->
<!--            :class="{ selected: selectedQuota.count === option.count }"-->
<!--            @click="selectQuota(option.count, option.price)"-->
<!--          >-->
<!--            <div class="quota-count">{{ option.count }}次</div>-->
<!--            <div class="quota-label">视频生成次数</div>-->
<!--            <div class="quota-price">¥{{ option.price }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <button class="btn-purchase-quota" @click="purchaseQuota" :disabled="!selectedQuota.count">立即购买</button>-->
<!--      </div>-->

      <div class="comparison-table">
        <h2>📊 权益对比表</h2>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>权益项</th>
                <th>游客</th>
                <th>注册用户</th>
                <th>月度会员</th>
                <th>终身会员</th>
                <th>说明</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="comparisonTableLoading">
                <td colspan="6" style="text-align: center; padding: 40px;">
                  <el-icon class="is-loading"><Loading /></el-icon>
                  <p style="margin-top: 10px;">正在加载权益对比表...</p>
                </td>
              </tr>
              <tr v-else-if="comparisonTable.length === 0">
                <td colspan="6" style="text-align: center; padding: 40px;">
                  暂无权益对比数据
                </td>
              </tr>
              <tr v-else v-for="row in comparisonTable" :key="row.privilege_key">
                <td>{{ row.privilege_name }}</td>
                <td>{{ row.guest_value }}</td>
                <td>{{ row.registered_value }}</td>
                <td>{{ row.monthly_value }}</td>
                <td>{{ row.lifetime_value }}</td>
                <td>{{ row.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 支付二维码弹窗 -->
    <el-dialog
      v-model="paymentDialogVisible"
      title="请使用微信扫码支付"
      width="400px"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      @close="handlePaymentCancel"
    >
      <div class="payment-qrcode-container">
        <div v-if="qrcodeLoading" class="qrcode-loading">
          <el-icon class="is-loading"><Loading /></el-icon>
          <p>正在生成支付二维码...</p>
        </div>
        <div v-else-if="qrcodeError" class="qrcode-error">
          <el-icon><WarningFilled /></el-icon>
          <p>{{ qrcodeError }}</p>
          <el-button type="primary" @click="loadQRCode">重试</el-button>
        </div>
        <div v-else class="qrcode-wrapper">
          <img :src="qrcodeImageUrl" alt="支付二维码" class="qrcode-image" />
          <p class="qrcode-order">订单号：{{ currentOrderId }}</p>
        </div>
      </div>
    </el-dialog>

    <!-- 会员服务协议弹窗 -->
    <el-dialog
      v-model="agreementDialogVisible"
      width="800px"
      :close-on-click-modal="!isForcedAgreement"
      :close-on-press-escape="!isForcedAgreement"
      :show-close="!isForcedAgreement"
      @close="handleAgreementClose"
    >
      <template #header>
        <span>{{ isForcedAgreement ? '请阅读会员服务协议' : '会员服务协议' }}</span>
      </template>
      <div v-if="agreementLoading" class="agreement-loading">
        <el-icon class="is-loading"><Loading /></el-icon>
        <p>正在加载协议内容...</p>
      </div>
      <div v-else-if="agreementContent" class="agreement-content" v-html="agreementContent"></div>
      <div v-else class="agreement-loading">
        <p>暂无协议内容</p>
      </div>
      <template v-if="isForcedAgreement" #footer>
        <div class="agreement-footer">
          <div v-if="agreementCountdown > 0" class="agreement-countdown">
            请仔细阅读协议，{{ agreementCountdown }}秒后可确认
          </div>
          <el-button
            type="primary"
            @click="confirmAgreementRead"
            :disabled="agreementCountdown > 0"
            size="large"
          >
            确认
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped>
.member-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  text-align: center;
  color: white;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}

.header p {
  font-size: 1.2em;
  opacity: 0.9;
}

.agreement-link {
  margin-top: 1rem;
  font-size: 0.9em;
  opacity: 0.95;
}

.agreement-link a {
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  transition: opacity 0.3s;
}

.agreement-link a:hover {
  opacity: 0.8;
}

.membership-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 40px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  align-items: stretch;
}

.card {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;
  border: 3px solid transparent;
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.card-selected {
  border: 3px solid #ffd700 !important;
}

.card.featured::before {
  content: "推荐";
  position: absolute;
  top: 15px;
  right: -30px;
  background: #ffd700;
  color: #333;
  padding: 5px 40px;
  transform: rotate(45deg);
  font-size: 12px;
  font-weight: bold;
}

.card-header {
  text-align: center;
  margin-bottom: 25px;
}

.card-title {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 10px;
}

.card-price {
  font-size: 2.5em;
  color: #667eea;
  font-weight: bold;
  margin-bottom: 5px;
}

.card-price-unit {
  font-size: 0.4em;
  color: #999;
}

.card-description {
  font-size: 0.9em;
  color: #666;
  margin-top: 5px;
}

.original-price {
  font-size: 0.5em;
  color: #999;
  text-decoration: line-through;
  margin-left: 8px;
}

.plans-loading {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: white;
  gap: 15px;
}

.plans-loading .el-icon {
  font-size: 40px;
}

.feature-icon.no {
  color: #ccc;
}

.card-features {
  list-style: none;
  margin-bottom: 30px;
  flex: 1;
}

.card-features li {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  font-size: 0.95em;
}

.card-features li:last-child {
  border-bottom: none;
}

.feature-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  font-size: 16px;
}

.feature-icon.yes {
  color: #4caf50;
}

.btn-purchase {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.3s ease;
  margin-top: auto;
}

.btn-purchase:hover {
  opacity: 0.9;
}

.btn-purchase:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.purchase-quota-section {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  margin-bottom: 40px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.purchase-quota-section h2 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-size: 1.8em;
}

.quota-status {
  background: #f0f4ff;
  border: 2px solid #667eea;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.quota-status-label {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 8px;
}

.quota-status-info {
  display: flex;
  justify-content: space-around;
  gap: 20px;
}

.quota-status-item-label {
  font-size: 0.85em;
  color: #999;
  margin-bottom: 5px;
}

.quota-status-item-value {
  font-size: 1.5em;
  font-weight: bold;
}

.quota-status-item-value.free {
  color: #4caf50;
}

.quota-status-item-value.purchased {
  color: #667eea;
}

.quota-status-item-value.total {
  color: #333;
}

.quota-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.quota-option {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.quota-option:hover {
  border-color: #667eea;
  background: #f8f9ff;
}

.quota-option.selected {
  border-color: #667eea;
  background: #f0f4ff;
}

.quota-count {
  font-size: 2em;
  font-weight: bold;
  color: #667eea;
  margin-bottom: 5px;
}

.quota-label {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 10px;
}

.quota-price {
  font-size: 1.3em;
  font-weight: bold;
  color: #333;
}

.btn-purchase-quota {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  display: block;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
}

.btn-purchase-quota:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.comparison-table {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  overflow-x: auto;
}

.comparison-table h2 {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-size: 2em;
}

.table-wrapper {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

th, td {
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

th {
  background: #f8f9fa;
  font-weight: bold;
  color: #333;
  position: sticky;
  left: 0;
  z-index: 1;
}

th:first-child {
  text-align: left;
  position: sticky;
  left: 0;
  background: #f8f9fa;
  z-index: 2;
}

td:first-child {
  text-align: left;
  font-weight: 500;
  background: #f8f9fa;
  position: sticky;
  left: 0;
  z-index: 1;
}

tr:hover {
  background: #f8f9fa;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  font-weight: bold;
}

.badge-temp {
  background: #e3f2fd;
  color: #1976d2;
}

.badge-user {
  background: #f3e5f5;
  color: #7b1fa2;
}

.badge-monthly {
  background: #fff3e0;
  color: #e65100;
}

.badge-lifetime {
  background: #fff9c4;
  color: #f57f17;
}

@media (max-width: 768px) {
  .membership-cards {
    grid-template-columns: 1fr;
    max-width: 100%;
  }


  .header h1 {
    font-size: 2em;
  }

  .quota-options {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .quota-count {
    font-size: 1.5em;
  }

  .quota-price {
    font-size: 1.1em;
  }

  .quota-status-info {
    flex-direction: column;
    gap: 10px;
  }
}

/* 支付二维码弹窗样式 */
.payment-qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-height: 300px;
}

.qrcode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  color: #666;
}

.qrcode-loading .el-icon {
  font-size: 40px;
  color: #667eea;
}

.qrcode-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  color: #f56c6c;
}

.qrcode-error .el-icon {
  font-size: 40px;
}

.qrcode-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.qrcode-image {
  width: 250px;
  height: 250px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  background: white;
}

.qrcode-tip {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin: 0;
}

.qrcode-order {
  font-size: 12px;
  color: #999;
  margin: 0;
}

/* 协议内容样式 */
.agreement-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
}

.agreement-content :deep(p) {
  margin: 10px 0;
}

.agreement-content :deep(strong) {
  font-weight: 600;
  color: #1890ff;
}

.agreement-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 40px;
  color: #666;
}

.agreement-loading .el-icon {
  font-size: 40px;
  color: #667eea;
}

.agreement-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px 0;
}

.agreement-countdown {
  font-size: 14px;
  color: #666;
  text-align: center;
}
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import apiClient from '@/components/plugins/axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Loading, WarningFilled } from '@element-plus/icons-vue'

const router = useRouter()
const route = useRoute()

// 会员信息 - 字段名与后端返回保持一致
const memberInfo = ref({
  memberLevelName: '', // 会员等级名称：'月度会员' | '终身会员' | '注册会员'
  memberLevel: '', // 会员等级：'monthly' | 'lifetime' | 'registered'
  memberId: '', // 会员ID
  expireDate: null, // 会员有效期至，格式：YYYY-MM-DD
})

// 选中的卡片
const selectedCard = ref(null)

// 支付二维码相关
const paymentDialogVisible = ref(false)
const qrcodeImageUrl = ref('')
const qrcodeLoading = ref(false)
const qrcodeError = ref('')
const currentOrderId = ref('')
const checkingPayment = ref(false)
const paymentCheckTimer = ref(null)

// 协议相关
const agreementDialogVisible = ref(false)
const agreementContent = ref('')
const agreementLoading = ref(false)
const isForcedAgreement = ref(false) // 是否是强制阅读协议
const agreementCountdown = ref(0) // 协议阅读倒计时
const agreementCountdownTimer = ref(null) // 倒计时定时器
const pendingOrderId = ref('') // 待处理的订单ID

// 判断是否是终身会员
const isLifetimeMember = computed(() => {
  return memberInfo.value.memberLevel === 'lifetime'
})

// 选择卡片
function selectCard(cardType) {
  if (isLifetimeMember.value) {
    return // 终身会员不允许选择
  }
  // 直接切换选中状态，确保只有一个卡片被选中
  selectedCard.value = selectedCard.value === cardType ? null : cardType
}

// 加载会员信息
async function loadMemberInfo() {
  try {
    const res = await apiClient.get('/api/v1/member/center/info')

    if (res.data && res.data.code === 200) {
      const data = res.data.data

      // 更新会员信息 - 直接使用后端返回的数据，不做任何转换
      if (data.member_info) {
        memberInfo.value = data.member_info
      }
    }
  } catch (error) {
    console.error('加载会员信息失败:', error)
  }
}

// 加载会员套餐数据
async function loadMemberPlans() {
  plansLoading.value = true
  try {
    const res = await apiClient.get('/api/v1/member/level/plans')

    if (res.data && res.data.code === 200) {
      const plans = res.data.data || []

      // 根据 level 字段分别存储月度会员和终身会员数据
      monthlyPlan.value = plans.find(plan => plan.level === 'monthly') || null
      lifetimePlan.value = plans.find(plan => plan.level === 'lifetime') || null
    } else {
      ElMessage.error(res.data?.message || '加载会员套餐失败')
    }
  } catch (error) {
    console.error('加载会员套餐失败:', error)
    ElMessage.error('加载会员套餐失败，请稍后重试')
  } finally {
    plansLoading.value = false
  }
}

// 加载权益对比表
async function loadComparisonTable() {
  comparisonTableLoading.value = true
  try {
    const res = await apiClient.get('/api/v1/member/get_privilege_comparison')

    if (res.data && res.data.code === 200) {
      const data = res.data.data
      const privileges = data.privileges || []

      // 根据 display_order 排序
      privileges.sort((a, b) => {
        // 先按 display_order 排序
        if (a.display_order !== b.display_order) {
          return a.display_order - b.display_order
        }
        // 如果 display_order 相同，按 privilege_key 排序
        return a.privilege_key.localeCompare(b.privilege_key)
      })

      comparisonTable.value = privileges
    } else {
      ElMessage.error(res.data?.message || '加载权益对比表失败')
    }
  } catch (error) {
    console.error('加载权益对比表失败:', error)
    ElMessage.error('加载权益对比表失败，请稍后重试')
  } finally {
    comparisonTableLoading.value = false
  }
}

// 显示会员服务协议
async function showAgreement() {
  agreementDialogVisible.value = true

  // 如果已经加载过协议内容，直接显示
  if (agreementContent.value) {
    return
  }

  // 加载协议内容
  agreementLoading.value = true
  try {
    const res = await apiClient.get('/api/v1/common/get/web_membership_agreement')

    if (res.data && res.data.code === 200) {
      agreementContent.value = res.data.data.web_membership_agreement || ''
    } else {
      ElMessage.error(res.data?.message || '加载协议失败')
    }
  } catch (error) {
    console.error('加载协议失败:', error)
    ElMessage.error('加载协议失败，请稍后重试')
  } finally {
    agreementLoading.value = false
  }
}

// 会员套餐数据（从接口获取）
const monthlyPlan = ref(null)
const lifetimePlan = ref(null)
const plansLoading = ref(false)

// 购买次数选项
const quotaOptions = ref([
  { count: 10, price: 9.9 },
  { count: 30, price: 24.9 },
  { count: 50, price: 39.9 },
  { count: 100, price: 69.9 }
])

// 选中的次数套餐
const selectedQuota = ref({
  count: 50,
  price: 39.9
})

// 当前次数状态
const currentQuota = ref({
  freeQuota: 4,
  freeTotal: 6,
  purchased: 6,
  total: 10
})

// 权益对比表（从接口获取）
const comparisonTable = ref([])
const comparisonTableLoading = ref(false)
const comparisonTable1 = ref([
  {
    item: '身份标识类型',
    visitor: { text: '临时ID', badgeClass: 'badge-temp' },
    user: { text: '用户ID', badgeClass: 'badge-user' },
    monthly: { text: '会员ID', badgeClass: 'badge-monthly' },
    lifetime: { text: '尊享ID', badgeClass: 'badge-lifetime' },
    note: '-'
  },
  {
    item: '清洁视频观看',
    visitor: true,
    user: true,
    monthly: true,
    lifetime: true,
    note: '基础引流内容'
  },
  {
    item: '所有视频观看',
    visitor: false,
    user: false,
    monthly: true,
    lifetime: true,
    note: '付费核心权益'
  },
  {
    item: '视频下载',
    visitor: false,
    user: false,
    monthly: '✅(带水印)',
    lifetime: '✅(带水印)',
    note: '带品牌水印'
  },
  {
    item: 'AI生成次数',
    visitor: '1次(终身)',
    user: '3次(永久)',
    monthly: '6次/月',
    lifetime: '10次/月',
    note: '核心差异点'
  },
  {
    item: '生成视频观看',
    visitor: '仅1次/视频',
    user: '仅1次/视频',
    monthly: '无限次',
    lifetime: '无限次',
    note: '防止游客滥用'
  },
  {
    item: '客服优先响应',
    visitor: false,
    user: false,
    monthly: true,
    lifetime: true,
    note: '响应时间<30s'
  },
  {
    item: '离线缓存',
    visitor: false,
    user: false,
    monthly: true,
    lifetime: true,
    note: '仅限APP端'
  },
  {
    item: '邀请奖励',
    visitor: false,
    user: true,
    monthly: true,
    lifetime: true,
    note: '裂变激励'
  },
  {
    item: '价格',
    visitor: '免费',
    user: '免费',
    monthly: '1.99元/月',
    lifetime: '29元一次性',
    note: '-'
  }
])
// 检查协议阅读状态
async function checkAgreementStatus() {
  try {
    const res = await apiClient.get('/api/v1/common/record/web_membership_agreement')

    if (res.data && res.data.code === 200) {
      return res.data.data === true // true表示已读，false表示未读
    }
    return false
  } catch (error) {
    console.error('检查协议阅读状态失败:', error)
    return false
  }
}

// 记录协议已读
async function recordAgreementRead() {
  try {
    const res = await apiClient.post('/api/v1/common/record/web_membership_agreement', {
      agreement_type: 'web_membership_agreement'
    })

    if (res.data && res.data.code === 200) {
      return true
    }
    return false
  } catch (error) {
    console.error('记录协议已读失败:', error)
    return false
  }
}

// 强制阅读协议
async function showForcedAgreement(orderId) {
  // 先加载协议内容
  if (!agreementContent.value) {
    agreementLoading.value = true
    try {
      const res = await apiClient.get('/api/v1/common/get/web_membership_agreement')

      if (res.data && res.data.code === 200) {
        agreementContent.value = res.data.data.web_membership_agreement || ''
      } else {
        ElMessage.error(res.data?.message || '加载协议失败')
        return
      }
    } catch (error) {
      console.error('加载协议失败:', error)
      ElMessage.error('加载协议失败，请稍后重试')
      return
    } finally {
      agreementLoading.value = false
    }
  }

  // 保存订单ID
  pendingOrderId.value = orderId

  // 设置强制阅读模式
  isForcedAgreement.value = true
  agreementCountdown.value = 5

  // 显示协议弹窗
  agreementDialogVisible.value = true

  // 开始倒计时
  agreementCountdownTimer.value = setInterval(() => {
    agreementCountdown.value--
    if (agreementCountdown.value <= 0) {
      clearInterval(agreementCountdownTimer.value)
      agreementCountdownTimer.value = null
    }
  }, 1000)
}

// 确认已阅读协议
async function confirmAgreementRead() {
  if (agreementCountdown.value > 0) {
    return
  }

  // 记录协议已读
  const success = await recordAgreementRead()
  if (!success) {
    ElMessage.error('记录协议阅读状态失败，请稍后重试')
    return
  }

  // 关闭协议弹窗
  agreementDialogVisible.value = false
  isForcedAgreement.value = false

  // 清除倒计时
  if (agreementCountdownTimer.value) {
    clearInterval(agreementCountdownTimer.value)
    agreementCountdownTimer.value = null
  }
  agreementCountdown.value = 0

  // 显示支付二维码
  if (pendingOrderId.value) {
    currentOrderId.value = pendingOrderId.value
    pendingOrderId.value = ''
    await loadQRCode()
  }
}

// 处理协议弹窗关闭
function handleAgreementClose() {
  // 如果是强制阅读模式，不允许关闭
  if (isForcedAgreement.value) {
    // 阻止关闭，重新打开弹窗
    agreementDialogVisible.value = true
    return
  }

  // 非强制模式下，正常关闭
  // 清除倒计时
  if (agreementCountdownTimer.value) {
    clearInterval(agreementCountdownTimer.value)
    agreementCountdownTimer.value = null
  }
  agreementCountdown.value = 0
}

// 购买会员
async function purchaseMembership(type) {
  // 如果是终身会员，不允许再次开通
  if (isLifetimeMember.value) {
    ElMessage.warning('您已经是终身会员，无需再次开通')
    return
  }

  // 从接口获取的套餐数据中获取信息
  const plan = type === 'monthly' ? monthlyPlan.value : lifetimePlan.value
  if (!plan) {
    ElMessage.error('会员套餐信息未加载，请刷新页面重试')
    return
  }

  const membershipInfo = {
    monthly: {
      name: plan.name,
      price: plan.member_price,
      type: 'monthly',
      apiPath: '/api/v1/member/upgrade/monthly'
    },
    lifetime: {
      name: plan.name,
      price: plan.member_price,
      type: 'lifetime',
      apiPath: '/api/v1/member/upgrade/lifetime'
    }
  }

  const info = membershipInfo[type]
  if (!info) {
    ElMessage.error('无效的会员类型')
    return
  }

  try {
    // 调用开通会员接口
    ElMessage.info('正在创建订单，请稍候...')

    const response = await apiClient.post(info.apiPath, {
      payment_channel: 'wechat',
      upgrade_notes: ''
    })

    // 处理响应
    if (response.data && response.data.code === 200) {
      const orderId = response.data.data?.order_id
      if (!orderId) {
        throw new Error('订单创建失败，未返回订单ID')
      }

      // 检查协议阅读状态
      const hasReadAgreement = await checkAgreementStatus()

      if (hasReadAgreement) {
        // 已读协议，直接显示支付二维码
        currentOrderId.value = orderId
        await loadQRCode()
      } else {
        // 未读协议，强制阅读协议
        await showForcedAgreement(orderId)
      }
    } else {
      throw new Error(response.data?.msg || response.data?.message || '开通失败')
    }
  } catch (error) {
    console.error('开通会员失败:', error)
    const errorMessage = error.response?.data?.message || error.message || '开通会员失败，请稍后重试'
    ElMessage.error(errorMessage)
  }
}

// 加载支付二维码
async function loadQRCode() {
  if (!currentOrderId.value) {
    ElMessage.error('订单ID不存在')
    return
  }

  qrcodeLoading.value = true
  qrcodeError.value = ''

  try {
    // 由于接口直接返回图片，需要使用 responseType: 'blob'
    const response = await apiClient.get('/api/v1/payment/qrcode/image', {
      params: {
        order_number: currentOrderId.value
      },
      responseType: 'blob'
    })

    // 将响应转换为blob，然后创建URL
    const blob = response.data
    qrcodeImageUrl.value = URL.createObjectURL(blob)

    // 显示支付弹窗
    paymentDialogVisible.value = true

    // 开始轮询检查支付状态
    startPaymentCheck()
  } catch (error) {
    console.error('加载二维码失败:', error)
    qrcodeError.value = error.response?.data?.message || error.message || '获取支付二维码失败，请稍后重试'
    qrcodeImageUrl.value = ''
  } finally {
    qrcodeLoading.value = false
  }
}

// 开始轮询检查支付状态
function startPaymentCheck() {
  // 清除之前的定时器
  if (paymentCheckTimer.value) {
    clearInterval(paymentCheckTimer.value)
  }

  // 每3秒检查一次支付状态
  paymentCheckTimer.value = setInterval(() => {
    checkPaymentStatus(true) // true表示静默检查
  }, 3000)
}

// 检查支付状态
async function checkPaymentStatus(silent = false) {
  if (!currentOrderId.value) {
    return
  }

  if (!silent) {
    checkingPayment.value = true
  }

  try {
    // 调用支付详情接口检查支付状态
    const response = await apiClient.get(`/api/v1/payment/detail_by_no/${currentOrderId.value}`)

    if (response.data && response.data.code === 200) {
      const orderData = response.data.data

      // 检查订单状态
      if (orderData.order_status === 'paid') {
        // 支付成功，处理支付成功逻辑
        handlePaymentSuccess()
        return
      }

      // 如果用户手动点击"我已支付"按钮，也检查一次
      if (!silent) {
        ElMessage.info('正在验证支付状态...')
        // 如果订单状态不是已支付，提示用户
        if (orderData.order_status !== 'paid') {
          ElMessage.warning('订单尚未支付，请完成支付后重试')
        }
      }
    } else {
      throw new Error(response.data?.message || '获取订单状态失败')
    }
  } catch (error) {
    console.error('检查支付状态失败:', error)
    if (!silent) {
      ElMessage.error(error.response?.data?.message || error.message || '检查支付状态失败，请稍后重试')
    }
  } finally {
    if (!silent) {
      checkingPayment.value = false
    }
  }
}

// 支付成功处理
async function handlePaymentSuccess() {
  // 清除定时器
  if (paymentCheckTimer.value) {
    clearInterval(paymentCheckTimer.value)
    paymentCheckTimer.value = null
  }

  // 关闭支付弹窗
  paymentDialogVisible.value = false

  // 清理二维码图片URL
  if (qrcodeImageUrl.value) {
    URL.revokeObjectURL(qrcodeImageUrl.value)
    qrcodeImageUrl.value = ''
  }

  // 记录协议已读（支付成功后）
  await recordAgreementRead()

  ElMessage.success('支付成功！会员开通成功！')

  // 重新加载会员信息
  await loadMemberInfo()

  // 触发自定义事件，通知其他组件更新
  window.dispatchEvent(new Event('auth-change'))

  // 支付成功后跳转
  setTimeout(() => {
    // 检查URL中是否有return_url参数
    const returnUrl = route.query.return_url
    if (returnUrl && typeof returnUrl === 'string') {
      // 如果有return_url，跳转到指定路由
      router.push(returnUrl)
    } else {
      // 如果没有return_url，正常跳转到会员权益页面
      router.push('/memberBenefits')
    }
  }, 800)
}

// 取消支付
function handlePaymentCancel() {
  // 清除定时器
  if (paymentCheckTimer.value) {
    clearInterval(paymentCheckTimer.value)
    paymentCheckTimer.value = null
  }

  // 关闭支付弹窗
  paymentDialogVisible.value = false

  // 清理二维码图片URL
  if (qrcodeImageUrl.value) {
    URL.revokeObjectURL(qrcodeImageUrl.value)
    qrcodeImageUrl.value = ''
  }

  // 清空订单ID
  currentOrderId.value = ''
  qrcodeError.value = ''

  ElMessage.info('已取消支付')
}

// 调用微信支付JSAPI
function callWeChatPay(type, info) {
  fetch('/api/payment/wechat/jsapi', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type: type,
      price: info.price
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.code === 0 && data.paymentParams) {
      const params = data.paymentParams

      // 调用微信支付
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          "appId": params.appId,
          "timeStamp": params.timeStamp,
          "nonceStr": params.nonceStr,
          "package": params.package,
          "signType": params.signType,
          "paySign": params.paySign
        },
        function(res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            alert('支付成功！')
            router.push('/member/success')
          } else {
            alert('支付失败：' + res.err_msg)
          }
        }
      )
    } else {
      alert('获取支付参数失败：' + (data.message || '未知错误'))
    }
  })
  .catch(error => {
    console.error('支付请求失败:', error)
    alert('支付请求失败，请稍后重试')
  })
}

// 选择次数套餐
function selectQuota(count, price) {
  selectedQuota.value = { count, price }
}

// 购买次数
function purchaseQuota() {
  if (!selectedQuota.value.count || !selectedQuota.value.price) {
    alert('请选择要购买的次数')
    return
  }

  if (confirm(`确定要购买 ${selectedQuota.value.count} 次视频生成次数吗？\n价格：¥${selectedQuota.value.price}`)) {
    // 调用后端接口获取支付参数
    if (typeof WeixinJSBridge !== 'undefined') {
      callWeChatPayForQuota()
    } else {
      const payUrl = `/api/payment/quota/create?count=${selectedQuota.value.count}&price=${selectedQuota.value.price}`
      window.location.href = payUrl
    }
  }
}

// 调用微信支付JSAPI购买次数
function callWeChatPayForQuota() {
  fetch('/api/payment/quota/wechat/jsapi', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      count: selectedQuota.value.count,
      price: selectedQuota.value.price
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.code === 0 && data.paymentParams) {
      const params = data.paymentParams

      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          "appId": params.appId,
          "timeStamp": params.timeStamp,
          "nonceStr": params.nonceStr,
          "package": params.package,
          "signType": params.signType,
          "paySign": params.paySign
        },
        function(res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            alert('购买成功！')
            router.push('/member/success')
          } else {
            alert('支付失败：' + res.err_msg)
          }
        }
      )
    } else {
      alert('获取支付参数失败：' + (data.message || '未知错误'))
    }
  })
  .catch(error => {
    console.error('支付请求失败:', error)
    alert('支付请求失败，请稍后重试')
  })
}

// 加载当前用户的次数状态
async function loadCurrentQuota() {
  try {
    // 这里应该调用后端API获取真实的次数信息
    // const res = await apiClient.get('/api/member/quota')
    // if (res.data && res.data.code === 200) {
    //   const data = res.data.data
    //   currentQuota.value = {
    //     freeQuota: data.freeQuotaRemaining || 0,
    //     freeTotal: data.freeQuotaTotal || 6,
    //     purchased: data.purchasedQuota || 0,
    //     total: (data.freeQuotaRemaining || 0) + (data.purchasedQuota || 0)
    //   }
    // }

    // 示例数据
    currentQuota.value = {
      freeQuota: 4,
      freeTotal: 6,
      purchased: 6,
      total: 10
    }
  } catch (error) {
    console.error('加载次数信息失败:', error)
  }
}

// 监听自定义事件（用于同标签页内同步）
const handleAuthChange = () => {
  loadMemberInfo()
}

onMounted(() => {
  loadCurrentQuota()
  loadMemberInfo()
  loadMemberPlans()
  loadComparisonTable()

  // 监听自定义事件（同标签页）
  window.addEventListener('auth-change', handleAuthChange)
})

onUnmounted(() => {
  // 清理事件监听器
  window.removeEventListener('auth-change', handleAuthChange)

  // 清理支付检查定时器
  if (paymentCheckTimer.value) {
    clearInterval(paymentCheckTimer.value)
    paymentCheckTimer.value = null
  }

  // 清理协议倒计时定时器
  if (agreementCountdownTimer.value) {
    clearInterval(agreementCountdownTimer.value)
    agreementCountdownTimer.value = null
  }

  // 清理二维码图片URL
  if (qrcodeImageUrl.value) {
    URL.revokeObjectURL(qrcodeImageUrl.value)
    qrcodeImageUrl.value = ''
  }
})
</script>

